// Assuming 'Chat_content' is imported from the same path
import { Chat_content } from "../../../Components/MessageApp/MessagesInterfaces";

// Placeholder imports for profile pictures and message images
import Cecilia from "./BuckinghamMessagesAssets/Message-ProfilePic-01.webp";
import Kasper from "./BuckinghamMessagesAssets/Message-ProfilePic-02.webp";
import picCecilia1 from "./BuckinghamMessagesAssets/Messages-Pic copy.webp";

export const BuckinghamMessageContent: Chat_content[] = [
  {
    icon: Cecilia,
    name: "Cecilia",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "Hiya darling, what will you be wearing on Saturday?",
        },
        timestamp: "2024-10-16T15:29:00.000Z", // 3:29pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Heyyyy Cecy, I’m wearing a bright pink Rêverie dress",
        },
        timestamp: "2024-10-16T15:41:00.000Z", // 3:41pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Gorgeous! That’s so on trend x",
        },
        timestamp: "2024-10-16T15:41:00.000Z", // 3:41pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "What are you wearing? x",
        },
        timestamp: "2024-10-16T15:44:00.000Z", // 3:44pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "I have a blue sequin gown from Maison de Lumière",
        },
        timestamp: "2024-10-16T15:45:00.000Z", // 3:45pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Aw, blue looks so good on you!",
        },
        timestamp: "2024-10-16T15:46:00.000Z", // 3:46pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I’d usually go for quite neutral makeup with blue, like beige eyeshadow and nude lipstick",
        },
        timestamp: "2024-10-16T15:48:00.000Z", // 3:48pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "But I’m considering going for something to stand out, like gold or red",
        },
        timestamp: "2024-10-16T15:48:00.000Z", // 3:48pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "What color shoes will you wear?",
        },
        timestamp: "2024-10-16T15:49:00.000Z", // 3:49pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I’m going into Kensington high street tomorrow so I’ll get some then - same thing, I was thinking beige or gold.",
        },
        timestamp: "2024-10-16T15:50:00.000Z", // 3:50pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "I think you should go with gold! It’s grandma’s 80th for heaven’s sake!",
        },
        timestamp: "2024-10-16T15:51:00.000Z", // 3:51pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "you’re so right! Do you have shoes to match?",
        },
        timestamp: "2024-10-16T15:52:00.000Z", // 3:52pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "yesssssssssss 💅",
        },
        timestamp: "2024-10-16T15:52:00.000Z", // 3:52pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "what color makeup will you have?",
        },
        timestamp: "2024-10-16T15:53:00.000Z", // 3:53pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Stacey will be doing it so I need to speak to her. She probably won’t let me do anything too crazy",
        },
        timestamp: "2024-10-16T15:55:00.000Z", // 3:55pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Probably peach or something",
        },
        timestamp: "2024-10-16T15:55:00.000Z", // 3:55pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "peach will go so well babe!",
        },
        timestamp: "2024-10-16T15:56:00.000Z", // 3:56pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Bella",
        },
        timestamp: "2024-10-19T22:32:00.000Z", // 10:32pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "just a warning - you should come to the cloak room to get between Margot and Kasper, they’re cuddling up to each other and getting super close and it’s weird.",
        },
        timestamp: "2024-10-19T22:32:00.000Z", // 10:32pm
        from: "Cecilia",
        status: "Read",
      },
      {
        content: {
          type: "photo",
          content: {
            image: picCecilia1, // Placeholder for Messages-Pic copy.webp
            date: "19 Oct 2024",
            time: " 10:32 PM",
            location: "",
          },
        },
        timestamp: "2024-10-19T22:32:00.000Z", // 10:32pm
        from: "Cecilia",
        status: "Read",
      },
    ],
  },
  {
    icon: Kasper,
    name: "Kasper",
    type: "individual",
    read: true,
    messages: [
      {
        content: {
          type: "text",
          content: "Hey can we call today x",
        },
        timestamp: "2024-10-16T11:13:00.000Z", // 11:13am
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes when are you free?",
        },
        timestamp: "2024-10-16T11:27:00.000Z", // 11:27am
        from: "Kasper",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Let’s talk this evening?",
        },
        timestamp: "2024-10-16T11:30:00.000Z", // 11:30am
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "That works",
        },
        timestamp: "2024-10-16T11:31:00.000Z", // 11:31am
        from: "Kasper",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Ok speak later x",
        },
        timestamp: "2024-10-16T11:32:00.000Z", // 11:32am
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Hi. I respect your decision but I don’t like how you broke the news to me yesterday. Did I not deserve more than a phone call? (That’s a rhetorical question, I don’t want you to answer). I’m upset, but as I said obviously I will still come to your grandmother’s party on Saturday. My father and I will land in London around midday. When and where should I meet you?",
        },
        timestamp: "2024-10-17T20:46:00.000Z", // 8:46pm
        from: "Kasper",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Hi. I’ll confirm our plans tomorrow, I need to speak to some people about our concrete plans.",
        },
        timestamp: "2024-10-17T21:23:00.000Z", // 9:23pm
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "thanks.",
        },
        timestamp: "2024-10-17T21:24:00.000Z", // 9:24pm (Corrected from 9:24am in CSV for logical flow)
        from: "Kasper",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Heyyyy, so we need to arrive at the party at 6:30pm. I’m having my makeup done at 4pm. We’ll send a car round to pick you up at 5:30pm, will you be in Hammersmith?",
        },
        timestamp: "2024-10-18T10:51:00.000Z", // 10:51am
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "Yes",
        },
        timestamp: "2024-10-18T11:03:00.000Z", // 11:03am
        from: "Kasper",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content:
            "Fantastic, the car will bring you to Kensington and we’ll all go together to the palace by 6:30pm, allowing for traffic. See you there!",
        },
        timestamp: "2024-10-18T11:09:00.000Z", // 11:09am
        from: "Arabella",
        status: "Read",
      },
      {
        content: {
          type: "text",
          content: "See you there.",
        },
        timestamp: "2024-10-18T11:10:00.000Z", // 11:10am
        from: "Kasper",
        status: "Read",
      },
    ],
  },
];
